/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
module App.HiLO.Directives {
    'use strict';

    export class TypeOfDocumentDirective implements angular.IDirective {

        public typeOfDocumentDirective() { };

        public transclude = false;

        public template: string;

        public restrict = 'E';

        public controller = HiLO.Controllers.TypeOfDocumentController;

        public controllerAs = 'td';

        public scope = {
            descriptionOfDeed: '=ngModel',
            otherDescriptionOfDeed: '=otherDescription',

        } as { [boundProperty: string]: string };

        public bindToController = true;

        public templateUrl = 'Templates/HiLO/Directives/TypeOfDocView.html';
        public require = ['ngModel'];
    }
    angular
        .module('app.hilo.directives')
        .directive('typeOfDocument', () => { return new TypeOfDocumentDirective(); });
}     